import styled from 'styled-components';

export const FlexWrap = styled.div(
  props => `
      display:flex
      `,
);

export const OuterWrapper = styled.div(
  props => `
      width:60.3rem;
      margin:0 auto;
      background:white;
      
      `,
);

export const ChildPaxInfo_Wrap = styled.div(
  props => `
    display:flex;
    width:100%;
    background:#e1f6f6;
    border-radius:12px;
    padding:${props.theme.spacing.custom(12)};
    margin:${props.theme.spacing.custom(30)} ${props.theme.spacing.large} ${
      props.theme.spacing.xlarge
    };
    `,
);

export const Left_wrap = styled.div(
  props => `
    display:flex;
    border-right: 1px solid #00a2ad;
    flex-direction: column;
    padding-right: ${props.theme.spacing.large};
    `,
);

export const Left_Header = styled.p(
  props => `
    font-size: ${props.theme.font.custom(14)};
    font-weight: 600;
    margin-bottom:${props.theme.spacing.small};
    `,
);

export const Right_wrap = styled.div(
  props => `
    display:flex;
    width:70%;
    padding-left: ${props.theme.spacing.large};
    flex-direction: column;
    justify-content:center;
    `,
);

export const List_Available = styled.ul(
  props => `
          width:100%;
          display:flex;
          flex-direction:column;
          li{
            display:flex;
            align-items: center;
            margin-bottom:${props.theme.spacing.large};
            &:last-child{
                margin-bottom:0;
            }
          }
            `,
);

export const List_text = styled.span(
  props => `
    color:#46484d;
    `,
);
